var map = {
	"./close_circle.svg": "203b",
	"./delete.svg": "0d45",
	"./download.svg": "f28e",
	"./edit.svg": "daf0",
	"./hand_add.svg": "6076",
	"./import.svg": "5d78",
	"./location.svg": "d2eb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b422";